import { render } from "./MergeConflictsPopup.vue?vue&type=template&id=475007f2&scoped=true"
import script from "./MergeConflictsPopup.vue?vue&type=script&lang=js"
export * from "./MergeConflictsPopup.vue?vue&type=script&lang=js"

import "./MergeConflictsPopup.vue?vue&type=style&index=0&id=475007f2&lang=css"
import "./MergeConflictsPopup.vue?vue&type=style&index=1&id=475007f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475007f2"]])

export default __exports__